import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { Styles, css } from '@flipster/styled-system/css';

import { intervalLeaderboardBunja } from './bunja';

interface TierDescriptionProps {
  css: Styles;
}
export const TierDescription = ({ css: cssProps }: TierDescriptionProps) => {
  const { currentTierInfo, currentTierDescriptionAtom } = useBunja(intervalLeaderboardBunja);
  const currentTierDescription = useAtomValue(currentTierDescriptionAtom);
  const description = currentTierDescription && (
    <>
      {currentTierInfo.label}: {currentTierDescription}
    </>
  );
  return (
    <p className={css({ textStyle: 'Text/S/Regular', color: 'content.default.level-1' }, cssProps)}>
      {description}
      <wbr />
    </p>
  );
};
